// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post_allFeedMainContainer__etYb1 {
  overflow: auto;
  height: 100%;
  scrollbar-width: thin;
  padding-bottom: 8px;
  overflow-x: hidden;
}

.post_allFeedMainContainer__etYb1 > * {
  max-width: 100%; /* Ensure children do not overflow horizontally */
  box-sizing: border-box; /* Include padding and borders in the width calculation */
}

.post_notFollowingContainer__f86jD {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60vh;
}
.post_post__-vAWu {
  padding: 10px 20px 10px 20px;
  background: white;
  /* max-width: fit-content; */
  margin: 10px 20px;
  border-radius: 20px;
  word-wrap: break-word; /* legacy support */
  overflow-wrap: anywhere; /* modern, allows wrapping without mid-word cuts */
  word-break: normal; /* prevents breaking inside words */
  white-space: normal; /* ensures wrapping is allowed */
}

.post_avatardetails__rvXpT {
  justify-content: space-between;
  display: flex;
  position: relative;
}
.post_profilename__3uPe7 {
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.post_sayoutlinedots__Y7a5K {
  position: relative;
  bottom: 3px;
  left: -17px;
}
.post_saysandfollow__TkY7h {
  display: flex;
  justify-content: space-between;
  padding: 5px 0px 0px 0px;
}
.post_noOfsays__JjQkz {
  display: flex;
  align-items: center;
  /* margin-left: 44px; */
  width: 100%;
  justify-content: center;
}
.post_noOfsays__JjQkz > a {
  cursor: pointer;
}
.post_noOfsays__JjQkz > a > p {
  margin: 0px;
}
.post_noOfsays__JjQkz span {
  font-size: 14px;
  padding-left: 10px;
  color: #373334;
}
.post_noOfsays__JjQkz img {
  position: relative;
}
.post_answerIcon__W77Qg {
  height: 28px;
  margin-right: -6px;
}
.post_replyIcon__1Wi5j {
  height: 18px;
  margin-right: -4px;
}
.post_noOffollows__U5bF7 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  /* margin-right: 44px; */
}
.post_noOffollows__U5bF7 span {
  font-size: 14px;
  padding-left: 10px;
  color: #373334;
}
.post_followtext__ypo4x {
  margin: 0px;
  padding-left: 10px;
  cursor: pointer;
}
.post_comment__JLWD4 {
  padding-top: 10px;
  display: flex;
}
.post_comment__JLWD4 > a > img {
  height: -moz-fit-content;
  height: fit-content;
  position: relative;
  right: 31px;
  top: 7px;
}
.post_followtext__ypo4x span {
  font-size: 14px;
  padding-left: 2px;
  color: #373334;
}
.post_commentinput__9wmQk {
  background-color: #f3f2f0;
  outline: none !important;
  padding: 10px 48px 10px 15px;
  /* padding: 9px 48px 9px 9px; */
  border: 0px solid #707070;
  width: 100%;
  margin-left: 10px;
  /* box-shadow: 0x 3px 6px; */
  /* min-width: 88%; */
  /* border-radius: 25px; */
  border-radius: 30px;
  height: 44px;
  resize: none;
  font-size: 14px;
}
.post_postedcomment__Qvv-- {
  display: flex;
  align-items: flex-start;
}
.post_likebutton__BIYRE {
  border: none;
  outline: none;
  margin-right: 10px;
}

.post_likeandlikecount__vU\\+W9 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 55px;
  margin-top: 0px;
  margin-bottom: 17px;

  /* keep all children on ONE line */
  white-space: nowrap;

  /* allow scrolling if overflow happens */
  overflow-x: auto;
  overflow-y: hidden;

  /* prevent ugly scrollbar (optional for Chrome) */
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}
.post_likeandlikecount__vU\\+W9 > a > img {
  /* height: fit-content;
    margin-top: 4px; */
  vertical-align: initial;
}
.post_likeandlikecount__vU\\+W9 > p {
  margin-left: 10px;
}

.post_dropdown__LW78n {
  position: relative;
  display: inline-block;
  bottom: 5px;
}
.post_dropdownlinks__agqlc {
  border: 1px solid black;
  display: none;
  position: absolute;
  right: 0;
  background-color: white;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.post_dropdown__LW78n:hover .post_dropdownlinks__agqlc {
  display: block;
}
.post_dropdownlinks__agqlc > Link {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.post_locationDet__iR7XQ {
  cursor: pointer;
}
.post_LocationPinIcon__nPnax {
  height: 30px;
}

.post_dropdownbutton__2CGNs {
  outline: none;
  background-color: white;
  color: white;
  /* padding: 16px; */
  font-size: 16px;
  border: none;
  cursor: pointer;
}
.post_dropdownlinks__agqlc > ul {
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
  list-style-type: none;
  color: blue;
  padding: 5px 0px 0px 5px;
}

.post_divider__yOvs1 {
  background: black !important;
  margin-bottom: 5px !important;
}

.post_avatar__F1OEq {
  margin-right: 8px;
  border-radius: 50% !important;
  width: 45px !important;
  height: 45px !important;
}

.post_profileimagetext__nin39 {
  /* overflow: hidden; */
  margin-left: 10px;
  background-color: #f3f2f0;
  padding: 13px 13px 10px 13px;
  border-radius: 25px;
  width: -webkit-fill-available;
  width: -moz-available;
}
.post_profileimagetext__nin39 > p {
  margin-bottom: 0;
}
.post_childResultMessage__QaEpI {
  width: 450px;
  flex-wrap: wrap;
  overflow: auto;
  white-space: normal;
}
.post_childsayprofilename__wQb2C {
  font-size: 14px;
  margin-bottom: 0;
}
.post_childsaysprofileandfdropdown__fL1AC {
  display: flex;
  justify-content: space-between;
  height: 25px;
}
.post_childdropdownbutton__drQy- {
  background-color: #f3f2f0 !important;
}
.post_locationAddressText__WQTUA{
  max-width: 160px;   /* adjust as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.7);
}
.post_locationWrapper__Z0uTE {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;       /* 🔑 REQUIRED for truncation */
  flex-shrink: 1;
}
.post_locationandtime__qHbFJ {
  display: flex; /* Align dot, icon, text in one row */
  font-size: 12px; /* Slightly smaller than time */
  color: #878585 !important;
  align-items: center; /* Vertical alignment */
  width: 100%; /* Allows ellipsis to work for location text */
}
.post_locationandtime__qHbFJ img {
  height: -moz-fit-content;
  height: fit-content;
  margin: 0px 3px 0px 3px;
}
.post_locationIcon__uputS {
  margin-top: 0px !important;
  margin-right: 3px !important;
}
.post_locationNameAndIconContainer__45sfx {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 3px;
}
.post_locationNameContent__MdGUt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 600px;
  display: inline-block;
  vertical-align: middle;
  font-size: 13px;
  cursor: pointer;
  margin-left: 2px;
}
.post_locationandtime__qHbFJ img:first-child {
  margin: 0 4px;
}
.post_followerandcount__n0oyn {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
.post_followerandcount__n0oyn > div > div {
  font-size: 11px;
  color: #373334;
}
.post_locationandtime__qHbFJ span:first-child {
  flex-shrink: 0;
}
.post_locationandtime__qHbFJ span:last-child {
  /* padding-left: 10px; */
  flex-shrink: 1;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.post_locationandtime__qHbFJ p {
  margin-bottom: 0px;
}
/* @media screen and (max-width: 992px) and (min-width: 768px) {
  .locationandtime span:last-child {
    max-width: 130px;
  }
} */
/* .askcount{
    width: 14px;
    height: 14px;
    color: white;
    font-size: 11px;
    border-radius: 50%;
    padding: 0 0 0 4px;
} */
.post_askcount__Df7Df {
  background-color: #2168b2;
  width: 14px;
  height: 14px;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  text-align: center;
}
.post_saycount__RvQyG {
  background-color: #45a735;
  width: 14px;
  height: 14px;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  text-align: center;
}
.post_updateCountContainer__HTOon {
  background-color: #e82727;
  width: 14px;
  height: 14px;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  text-align: center;
}
.post_tagcounter__uLlHB {
  background-color: #efba29;
  width: 25px;
  height: 15px;
  min-width: 15px;
  color: white;
  font-size: 10px;
  border-radius: 5px;
  text-align: center;
}
.post_nullTagCount__E4Az8,
.post_tagcount__t0oKR {
  background-color: #efba29;
  width: 15px;
  height: 15px;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  text-align: center;
}
.post_updatecount__wfVCc {
  background-color: #e82727;
  width: 14px;
  height: 14px;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  text-align: center;
}
.post_childsaycount__0tGIv {
  width: 14px;
  height: 14px;
  background-color: #36b549;
  color: white;
  font-size: 11px;
  border-radius: 50%;
  padding: 0 0 0 4px;
  position: absolute;
  right: 4px;
  bottom: 0px;
}

.post_childsayprofileimage__0Ue\\+6 {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
}
.post_childsaytextandcolorlabel__-caIV {
  display: flex;
  position: relative;
  font-size: 14px;
}
.post_childsaytextandcolorlabel__-caIV > div > p {
  margin-bottom: 0;
  font-size: 14px;
}
.post_dot__0t-GE {
  height: -moz-fit-content;
  height: fit-content;
  margin: 0px 6px;
}
.post_nooflikes__5zArq {
  font-size: 14px;
  margin: 3px 0px 0px 3px;
}
.post_spandisplay__cKZmp {
  display: flex;
  align-items: center;
  padding-left: 18px;
  /* width: 50%; */
}
.post_locationTimeSpan__8bNMZ {
  display: flex; /* Puts all children in a horizontal line */
  flex-direction: row; /* Ensure row layout (default but kept for clarity) */
  justify-content: flex-end; /* Push items to the right when no location */
  align-items: center; /* Perfect vertical alignment */
  margin-top: 2px; /* Small top spacing */
}
.post_locationTimeSpan__8bNMZ p {
  width: 100%;
}

.post_childSayLocTxt__mUDCG {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  display: block;
  box-sizing: border-box; /* It will Consider padding and borders in width calculation */
}

@media screen and (max-width: 420px) {
  .post_childSayLocTxt__mUDCG {
    width: 60%;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  .post_childSayLocTxt__mUDCG {
    width: 34%;
  }
}

.post_childsaytime__K04mw {
  margin-bottom: 0; /* Removes unwanted extra spacing */
  font-size: 13px; /* Time text size */
  margin-left: auto; /* Push time text to the right side */
  white-space: nowrap; /* Prevents wrapping (keeps in one line) */
}
.post_childsayopen__vLCGP {
  display: block;
}
.post_childsayselection__GaqmL {
  display: none;
  padding-top: 10px;
}
.post_saycountbottom__f5nEj {
  margin-bottom: 0;
}
.post_childpostBtnContainer__Y3SqP {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  gap: 5px;
}
.post_childpost__cLW9L {
  color: white;
  border-radius: 25px;
  padding: 2px 15px;
  border: none;
  outline: none;
  font-size: 14px;
  white-space: nowrap;
  flex-shrink: 0;
}
.post_childpostCancelBtn__81wjE {
  background: transparent;
  color: #373334;
  border-radius: 25px;
  padding: 2px 2px;
  border: none;
  outline: none;
  font-size: 14px;
  white-space: nowrap;
  flex-shrink: 0;
  outline: none !important;
}
.post_likeunlike__gL09U {
  display: flex;
  justify-content: center;
  margin-top: 3px;
}
.post_likeunlike__gL09U > a {
  cursor: pointer;
  font-size: 14px;
  color: #373334;
}
.post_likeunlike__gL09U > a > img {
  margin-right: 5px;
  position: relative;
  top: -1px;
}
.post_likeunlike__gL09U > p {
  margin-bottom: 0;
}
.post_likeunlike__gL09U > p > img {
  margin-right: 4px;
}
.post_followcount__Ksqkf {
  color: #878585;
  cursor: pointer;
  font-size: 12px;
  margin-top: 3px;
}
.post_childsaydropdowwbutton__5i-fq {
  background: none !important;
}
.post_postbuttonandlabel__Ssudu {
  display: flex;
  justify-content: space-between;
  min-width: 270px;
  font-size: 14px;
  align-items: first baseline;
}
.post_postbuttonandlabel__Ssudu > label {
  margin: 3px 10px 0px 0px;
}
.post_saveCancelButtonContainer__o2UMd {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: -5px;
  font-size: 14px;
}
.post_editPost__b1j3K {
  background-color: #2181ce;
  color: white;
  border-radius: 25px;
  padding: 2px 16px;
  border: none;
  outline: none;
  margin-top: 4px;
  font-size: 14px;
}
.post_editCancelPost__EnSw5{
  background: transparent;
  color: #373334;
  border-radius: 25px;
  padding: 8px 2px 2px 2px;
  border: none;
  outline: none;
  font-size: 14px;
  white-space: nowrap;
  flex-shrink: 0;
  outline: none !important;
}
.post_cancelPost__2LfZh {
  border-width: 0px;
  background-color: transparent;
  margin-left: 20px;
  font-size: 14px;
}

.post_postMessage__G28H2 {
  display: none;
  font-size: 14px;
}
.post_sendaMail__3PXSY {
  background: #2181ce;
  color: white;
  outline: none;
  border-radius: 25px;
  border: none;
  position: relative;
  top: 10px;
  align-self: center;
  left: 124px;
  padding: 3px 15px;
  margin-bottom: 20px;
  min-width: 88px;
}
.post_sendamailtextarea__Z-Z6P {
  min-width: 325px;
  border-radius: 0px;
  outline: none;
  border: solid 1px #dcdcdc;
  padding: 5px 12px;
  font-size: 14px;
}
.post_EditPostMessage__FkRs7 {
  position: relative;
  width: 100%;
  border: 10px;
  border-radius: 10px;
  padding: 8px 8px 10px 12px;
  overflow-y: scroll;
  scrollbar-width: none;
  border: 1px solid #707070;
  resize: none;
  font-size: 14px;
}
.post_postAttachmentIconsAndActionBtnMainTopContainer__TwIlX {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  padding-bottom: 10px;
}
.post_childAnsReplyPostBtnTopMainContainer__SrzFt {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  padding-bottom: 20px;
  padding-left: 50px;
}
.post_childAnsReplyPostBtnMainContainer__Z32yj {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  /* flex-wrap: wrap; */
  width: 100%;
  /* padding-bottom: 20px; */
}
.post_postAttachmentIconsAndActionBtnContainer__hmHMX {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  margin-bottom: -13px;
}
.post_postAttachmentIconsContainer__k88bi {
  display: flex;
  align-items: center;
  gap: 8px;
  /* flex-wrap: wrap; */
  margin-left: 5px;
}
.post_postLocationAttachmentTextContainer__q1Kg0 {
  display: flex;
  align-items: center;
  gap: 8px;
  /* flex-wrap: wrap; */
  margin-left: 5px;
}

.post_iconLabel__Kh50I {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.post_attachIcon__H7fTZ {
  height: 17px;
  margin-top: 5px;
}

.post_editLocationIcon__OU9Nd {
  position: absolute; /* Positions it relative to the textareaContainer */
  right: -4px; /* Adjust spacing from the right */
  top: 15px; /* Vertically centers the icon */
  transform: translateY(-50%); /* Corrects centering offset */
  cursor: pointer; /* Optional: Changes the cursor to a pointer */
}
.post_editLocationIconAndReminder__BluNH {
  position: absolute; /* Positions it relative to the textareaContainer */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  right: -4px; /* Adjust spacing from the right */
  top: 15px; /* Vertically centers the icon */
  transform: translateY(-20%); /* Corrects centering offset */
  padding: 2px 10px;
  height: 100%;
  cursor: pointer; /* Optional: Changes the cursor to a pointer */
}
.post_textareaContainer__0pm4Q {
  position: relative; /* Makes the parent a containing block for absolutely positioned children */
  width: 100%; /* Ensures the container wraps the textarea and icon */
  display: inline-block; /* Prevents the container from expanding unnecessarily */
  font-size: 14px;
}
.post_sendaMailModel__pi3T9 {
  display: flex;
}
.post_sendaMailModel__pi3T9 > div > img,
.post_postedcomment__Qvv-- > div > img {
  border-radius: 15px;
  border: solid 1px #707070;
}
.post_locationpinchildpost__qOR5D {
  position: relative;
  right: 20px;
  top: 9px;
}
.post_updatePopupLocationIcon__tZtr1 {
  margin-right: -5px;
  /* margin: 0px; */
}
.post_locationsearch__VYVPr {
  position: absolute;
  top: 3.2rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px;
  z-index: 10;
}
.post_dateTime__xxi6T {
  color: #707070;
  margin-top: 1.5px;
}
.post_calendarHeaderText__Pjgqp p {
  color: #373334;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 0px;
}
@media screen and (min-width: 1440px) {
  .post_calendarHeaderText__Pjgqp {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 36px;
    width: 265px;
    margin-top: -85px;
    margin-right: -268px;
    padding-bottom: -10px;
    border-style: solid;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom-width: 2px;
  }
  .post_calendarHeaderText__Pjgqp p {
    color: #373334;
    font-weight: 500;
    font-size: 19px;
  }
}
.post_comboboxdropdown__j-m0M {
  z-index: 1301;
}
.post_addlocation__baFQv {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.post_mapcontainer__p8Wk5 {
  width: 100%;
  padding: 0 15px 15px 15px;
}
.post_inputWrapper__R\\+7RN {
  display: flex;
  justify-content: center; /* keeps input centered */
  width: 100%;
}

.post_comboinput__V2sUl {
  width: 100%;
  min-width: 600px;
  min-height: 45px;
  border-radius: 25px;
  outline: none;
  border: none;
  box-sizing: border-box;
  box-shadow: 2px 2px 2px 0px #888;
  padding-left: 15px;
}
.post_locationheading__e3lht {
  margin-bottom: 0;
  color: #373334;
  font-size: 20px;
  font-weight: 600;
  margin-top: 2px;
}
.post_locationheading__e3lht span {
  font-weight: 700;
}
.post_locationSubmitAfterSelect__vst0q {
  outline: none;
  border: none;
  background-color: transparent;
  color: #4795de;
  font-weight: 500;
  font-size: 18px;
}
.post_locationSubmitBeforeSelect__8UmJQ {
  outline: none;
  border: none;
  background-color: transparent;
  color: #707070;
  font-weight: 500;
  font-size: 18px;
}
.post_locationSubmitButton__LW6\\+3 {
  color: #2181ce;
  background-color: transparent;
  border-width: 0px;
  outline: none !important;
}
.post_editBioInfo__aiMFW {
  display: block;
}
.post_editBioInfoNone__v3h8J {
  display: none;
}

/* The container */
.post_container__itRcV {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 0;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.post_container__itRcV > .post_containerinput__VIF1z {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.post_checkmark__xGYCf {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.post_container__itRcV:hover .post_containerinput__VIF1z ~ .post_checkmark__xGYCf {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.post_container__itRcV > .post_containerinput__VIF1z:checked ~ .post_checkmark__xGYCf {
  background-color: #2196f3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.post_checkmark__xGYCf:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.post_container__itRcV > .post_containerinput__VIF1z:checked ~ .post_checkmark__xGYCf:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.post_container__itRcV .post_checkmark__xGYCf:after {
  top: 5.9px;
  left: 5.9px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: white;
}
.post_postinfo__M4sfp {
  padding: 0px 0px 10px 12px;
}
.post_postinfo__M4sfp > p {
  margin-bottom: -8px;
  font-size: 17px;
}
.post_postinfo__M4sfp > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.post_postinfo__M4sfp > div > p {
  margin-top: 0px;
  font-size: 17px;
  color: #373334;
  font-weight: 500;
}
.post_aboutCommunity__tLPEL {
  font-weight: 400;
  font-size: 13px !important;
  color: #707070;
  margin-top: -20px;
}
.post_selectmultiplecommunitys__T1rPM {
  display: flex;
}
.post_selectmultiplecommunitys__T1rPM > div {
  margin-top: 0px;
  padding-left: 8px;
  cursor: pointer;
}
.post_selectmultiplecommunitys__T1rPM > div span {
  font-weight: 500;
}
.post_selectmultiplecommunitys__T1rPM > img {
  margin-left: 12px;
  margin-top: 3px;
  cursor: pointer;
  height: 18px;
}
.post_selectCount__s1hLx {
  color: #373334;
  font-weight: 500;
  margin-left: 5px;
}
.post_selectCommunityBtn__kAHF7 {
  color: #707070;
  cursor: pointer;
  margin-left: 5px;
}
.post_postingoptionsradio__W6av8 {
  display: flex;
  margin-top: 25px;
  justify-content: space-between;
}
.post_postingoptionschild__ogir4 {
  display: flex;
}
.post_postdropdown__uuwuV {
  float: right;
  position: relative;
  top: 5px;
  right: 2px;
  padding-left: 20px;
  cursor: pointer;
}
.post_disableRadioOptions__rmL\\+l {
  opacity: 0.5;
  pointer-events: none;
}
.post_warningmsg__9Z4jE {
  text-align: center;
  font-size: 12px;
  padding: 2px 4px;
  display: block;
  margin: 0;
  line-height: 1.2;
  text-align: left;
}
button,
a {
  cursor: pointer;
}
.post_moderatorcommunity__izEBp {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.post_moderatorcommunity__izEBp > img {
  width: 35px;
  height: 35px;
  border-radius: 12px;
  margin: 3px 18px 23px 10px;
}
.post_moderatorcommunity__izEBp > p {
  margin-top: 8px;
}
.post_moderatorcommunityparentdiv__yek8r {
  height: 400px;
  scroll-behavior: smooth;
  overflow-y: scroll;
  padding-top: 10px;
  scrollbar-width: none;
}
.post_moderatorcommunitychilddiv__MGyyO {
  display: flex;
  justify-content: space-between;
}
.post_inputCheckbox__h4yw8 {
  height: 18px;
  width: 18px;
}
.post_editBioTextArea__8B0iU {
  width: 100%;
  resize: none;
  padding: 3px 0 0 7px;
  border: 1px solid #707070;
  resize: none;
  border-radius: 5px;
  font-size: 14px;
}
.post_editbioSave__19ped {
  float: none !important;
  margin-top: 7px !important;
  margin-right: 5px !important;
  background-color: #337ab7;
  width: 65px;
  border-radius: 15px;
  color: #ffffff;
  font: bold;
  border: none;
  padding: 2px 8px;
}
.post_editbioCancel__ueqrU {
  margin-bottom: -5px;
}
@media all and (max-width: 767px) {
  .post_post__-vAWu {
    margin: 10px;
    padding: 10px;
  }
}

.post_deletePost__zvCmP {
  display: none;
}

.post_privateTagButtonContainer__5E8Xv {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding-top: 5px;
}
.post_privateButton__3ggb0 {
  border-width: 0px;
  background-color: transparent;
  outline: none !important;
  width: 50%;
  padding: 2px !important;
}
.post_privateButtonDescriptionContainer__Botcy {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.post_privateButtonIconImage__GBQgz {
  height: 16px;
  margin-right: 6px;
}
.post_privateButtonParagraph__Tp2hN {
  font-weight: 400;
  font-size: 14px;
  color: #63555a;
  text-transform: none;
  margin: 0px;
}
.post_profileMessagePopupMainContainer__KC18b {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
.post_privateTagdDownArrowButton__9\\+Zcs {
  border-width: 0px;
  background-color: transparent;
  margin-right: 10px;
  cursor: pointer;
  margin-bottom: 10px;
}
.post_privateTagdDownArrowButton__9\\+Zcs:focus {
  outline: 0px solid blue;
}
.post_downArrow__In1Ff {
  font-size: 23px;
  font-weight: 100;
}
.post_privateTagPopup__8ZES3 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px 10px;
}
.post_privateTagPopupItemButton__5di2P {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  border-width: 0px;
  background-color: transparent;
}
.post_privateTagPopupItemButton__5di2P:focus {
  outline: 0px solid blue;
}
.post_editIcon__fXcSR {
  height: 15px;
  margin-right: 12px;
  margin-top: 4px;
}
.post_privatePopuoTagName__3HW1A {
  font-weight: 500;
  font-size: 16px;
  color: #63555a;
}
.post_loaderContainer__WbBqj {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 15px;
}
.post_modalFooter__yKVU9 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  margin: auto;
}
.post_notFoundImageContainer__XKwYF {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 8px;
}
.post_notFoundImageContainerParagraph1__oaFxY{
  font-size: 18px;
  color: #707070;
  
}
.post_notFoundImageContainerParagraph2__YxX\\+Y{
  color: #373334;
  font-size: 17px;
}


.post_contentClass__s2Tu2 {
  background-color: #4795de;
}

.post_alertModal__yZ17x {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.post_alertModal__yZ17x div {
  cursor: pointer;
  margin-left: auto;
}

.post_alertModalContent__ghic6 {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  z-index: 1401; /* Higher than the modal container */
}
.post_avatarWrapper__UVKm6 {
  position: relative;
  display: inline-block;
}

.post_crown__C1PGL {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px; /* Adjust the size of the crown icon */
  height: 20px;
  margin-right: 6px;
  margin-bottom: 6px;
}
.post_activityAskPost__5pNn9 {
  background-color: rgba(0, 0, 0, 0.2);
}
.post_restrictionTestUnderSayPost__A1Yva {
  color: gray;
  text-align: center;
  font-size: 15px;
}
.post_locationCharContainer__PH6fP {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: 8px;
  flex-wrap: nowrap;
  overflow: hidden;
}
.post_locationText__3dffM {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.post_saveCancelBtnContainer__MtKVZ {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.post_childSayLocText__ieoDk {
  max-width: 300px; /* Limit width for long location names */
  white-space: nowrap; /* Prevent multi-line wrapping */
  overflow: hidden; /* Hide overflow text */
  text-overflow: ellipsis; /* Add "..." when truncated */
}
.post_childfileItem__VuXU3 {
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 14px;
}
.post_childfileLocationItem__zK9X\\+ {
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  padding: 4px 1px;
  font-size: 14px;
}

.post_childfileName__DOsl6 {
  color: #707070;
  font-weight: 500;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.post_childfileLocationName__otYuq {
  color: #707070;
  font-weight: 500;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.post_removeBtn__LNK4J {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  outline: none !important;
  border-radius: 50%;
  background-color: #f4f4f4;
  padding: 4px;
}
.post_deleteIcon__V6Z7h {
  height: 16px;
  width: 16px;
}

/* ✅ NEW: outer wrapper must allow shrinking */
.post_calendarWrapper__qfd5x {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;       /* 🔑 REQUIRED for truncation */
  flex-shrink: 1;
}

/* ✅ NEW: text container */
.post_calendarTextWrapper__12Ps7 {
  display: flex;
  align-items: center;
  min-width: 0;       /* 🔑 REQUIRED */
  flex-shrink: 1;
}

/* ✅ NEW: truncation instead of wrapping */
.post_calendarDateText__HMMLT {
  max-width: 140px;   /* adjust based on modal width */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/post.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,iDAAiD;EAClE,sBAAsB,EAAE,yDAAyD;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB,EAAE,mBAAmB;EAC1C,uBAAuB,EAAE,kDAAkD;EAC3E,kBAAkB,EAAE,mCAAmC;EACvD,mBAAmB,EAAE,gCAAgC;AACvD;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;;EAEnB,kCAAkC;EAClC,mBAAmB;;EAEnB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;;EAElB,iDAAiD;EACjD,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE;sBACoB;EACpB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB,IAAI,qBAAqB;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY,QAAQ,+BAA+B;EACnD,cAAc;AAChB;AACA;EACE,aAAa,EAAE,qCAAqC;EACpD,eAAe,EAAE,+BAA+B;EAChD,yBAAyB;EACzB,mBAAmB,EAAE,uBAAuB;EAC5C,WAAW,EAAE,8CAA8C;AAC7D;AACA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;;;;GAIG;AACH;;;;;;;GAOG;AACH;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa,EAAE,2CAA2C;EAC1D,mBAAmB,EAAE,qDAAqD;EAC1E,yBAAyB,EAAE,6CAA6C;EACxE,mBAAmB,EAAE,+BAA+B;EACpD,eAAe,EAAE,sBAAsB;AACzC;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,sBAAsB,EAAE,8DAA8D;AACxF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB,EAAE,mCAAmC;EACrD,eAAe,EAAE,mBAAmB;EACpC,iBAAiB,EAAE,qCAAqC;EACxD,mBAAmB,EAAE,0CAA0C;AACjE;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB,EAAE,mDAAmD;EACvE,WAAW,EAAE,kCAAkC;EAC/C,SAAS,EAAE,gCAAgC;EAC3C,2BAA2B,EAAE,8BAA8B;EAC3D,eAAe,EAAE,8CAA8C;AACjE;AACA;EACE,kBAAkB,EAAE,mDAAmD;EACvE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW,EAAE,kCAAkC;EAC/C,SAAS,EAAE,gCAAgC;EAC3C,2BAA2B,EAAE,8BAA8B;EAC3D,iBAAiB;EACjB,YAAY;EACZ,eAAe,EAAE,8CAA8C;AACjE;AACA;EACE,kBAAkB,EAAE,2EAA2E;EAC/F,WAAW,EAAE,sDAAsD;EACnE,qBAAqB,EAAE,wDAAwD;EAC/E,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB,EAAE,yBAAyB;EAClD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,wBAAwB;EACxB,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;;AAEhB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa,EAAE,oCAAoC;AACrD;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW,EAAE,sCAAsC;EACnD,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB,EAAE,wCAAwC;EAC1D,mBAAmB,EAAE,gCAAgC;EACrD,gBAAgB,EAAE,uBAAuB;EACzC,uBAAuB,EAAE,6BAA6B;AACxD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY,QAAQ,+BAA+B;EACnD,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,QAAQ,gBAAgB;EACpC,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB,IAAI,gCAAgC;EACpD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".allFeedMainContainer {\r\n  overflow: auto;\r\n  height: 100%;\r\n  scrollbar-width: thin;\r\n  padding-bottom: 8px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.allFeedMainContainer > * {\r\n  max-width: 100%; /* Ensure children do not overflow horizontally */\r\n  box-sizing: border-box; /* Include padding and borders in the width calculation */\r\n}\r\n\r\n.notFollowingContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 60vh;\r\n}\r\n.post {\r\n  padding: 10px 20px 10px 20px;\r\n  background: white;\r\n  /* max-width: fit-content; */\r\n  margin: 10px 20px;\r\n  border-radius: 20px;\r\n  word-wrap: break-word; /* legacy support */\r\n  overflow-wrap: anywhere; /* modern, allows wrapping without mid-word cuts */\r\n  word-break: normal; /* prevents breaking inside words */\r\n  white-space: normal; /* ensures wrapping is allowed */\r\n}\r\n\r\n.avatardetails {\r\n  justify-content: space-between;\r\n  display: flex;\r\n  position: relative;\r\n}\r\n.profilename {\r\n  margin-bottom: 0px;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n.sayoutlinedots {\r\n  position: relative;\r\n  bottom: 3px;\r\n  left: -17px;\r\n}\r\n.saysandfollow {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 5px 0px 0px 0px;\r\n}\r\n.noOfsays {\r\n  display: flex;\r\n  align-items: center;\r\n  /* margin-left: 44px; */\r\n  width: 100%;\r\n  justify-content: center;\r\n}\r\n.noOfsays > a {\r\n  cursor: pointer;\r\n}\r\n.noOfsays > a > p {\r\n  margin: 0px;\r\n}\r\n.noOfsays span {\r\n  font-size: 14px;\r\n  padding-left: 10px;\r\n  color: #373334;\r\n}\r\n.noOfsays img {\r\n  position: relative;\r\n}\r\n.answerIcon {\r\n  height: 28px;\r\n  margin-right: -6px;\r\n}\r\n.replyIcon {\r\n  height: 18px;\r\n  margin-right: -4px;\r\n}\r\n.noOffollows {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  justify-content: center;\r\n  /* margin-right: 44px; */\r\n}\r\n.noOffollows span {\r\n  font-size: 14px;\r\n  padding-left: 10px;\r\n  color: #373334;\r\n}\r\n.followtext {\r\n  margin: 0px;\r\n  padding-left: 10px;\r\n  cursor: pointer;\r\n}\r\n.comment {\r\n  padding-top: 10px;\r\n  display: flex;\r\n}\r\n.comment > a > img {\r\n  height: fit-content;\r\n  position: relative;\r\n  right: 31px;\r\n  top: 7px;\r\n}\r\n.followtext span {\r\n  font-size: 14px;\r\n  padding-left: 2px;\r\n  color: #373334;\r\n}\r\n.commentinput {\r\n  background-color: #f3f2f0;\r\n  outline: none !important;\r\n  padding: 10px 48px 10px 15px;\r\n  /* padding: 9px 48px 9px 9px; */\r\n  border: 0px solid #707070;\r\n  width: 100%;\r\n  margin-left: 10px;\r\n  /* box-shadow: 0x 3px 6px; */\r\n  /* min-width: 88%; */\r\n  /* border-radius: 25px; */\r\n  border-radius: 30px;\r\n  height: 44px;\r\n  resize: none;\r\n  font-size: 14px;\r\n}\r\n.postedcomment {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n.likebutton {\r\n  border: none;\r\n  outline: none;\r\n  margin-right: 10px;\r\n}\r\n\r\n.likeandlikecount {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  margin-left: 55px;\r\n  margin-top: 0px;\r\n  margin-bottom: 17px;\r\n\r\n  /* keep all children on ONE line */\r\n  white-space: nowrap;\r\n\r\n  /* allow scrolling if overflow happens */\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n\r\n  /* prevent ugly scrollbar (optional for Chrome) */\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #ccc transparent;\r\n}\r\n.likeandlikecount > a > img {\r\n  /* height: fit-content;\r\n    margin-top: 4px; */\r\n  vertical-align: initial;\r\n}\r\n.likeandlikecount > p {\r\n  margin-left: 10px;\r\n}\r\n\r\n.dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n  bottom: 5px;\r\n}\r\n.dropdownlinks {\r\n  border: 1px solid black;\r\n  display: none;\r\n  position: absolute;\r\n  right: 0;\r\n  background-color: white;\r\n  min-width: 160px;\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n  z-index: 1;\r\n}\r\n.dropdown:hover .dropdownlinks {\r\n  display: block;\r\n}\r\n.dropdownlinks > Link {\r\n  color: black;\r\n  padding: 12px 16px;\r\n  text-decoration: none;\r\n  display: block;\r\n}\r\n\r\n.locationDet {\r\n  cursor: pointer;\r\n}\r\n.LocationPinIcon {\r\n  height: 30px;\r\n}\r\n\r\n.dropdownbutton {\r\n  outline: none;\r\n  background-color: white;\r\n  color: white;\r\n  /* padding: 16px; */\r\n  font-size: 16px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n.dropdownlinks > ul {\r\n  margin-bottom: 0.5rem;\r\n  font-size: 0.8rem;\r\n  list-style-type: none;\r\n  color: blue;\r\n  padding: 5px 0px 0px 5px;\r\n}\r\n\r\n.divider {\r\n  background: black !important;\r\n  margin-bottom: 5px !important;\r\n}\r\n\r\n.avatar {\r\n  margin-right: 8px;\r\n  border-radius: 50% !important;\r\n  width: 45px !important;\r\n  height: 45px !important;\r\n}\r\n\r\n.profileimagetext {\r\n  /* overflow: hidden; */\r\n  margin-left: 10px;\r\n  background-color: #f3f2f0;\r\n  padding: 13px 13px 10px 13px;\r\n  border-radius: 25px;\r\n  width: -webkit-fill-available;\r\n  width: -moz-available;\r\n}\r\n.profileimagetext > p {\r\n  margin-bottom: 0;\r\n}\r\n.childResultMessage {\r\n  width: 450px;\r\n  flex-wrap: wrap;\r\n  overflow: auto;\r\n  white-space: normal;\r\n}\r\n.childsayprofilename {\r\n  font-size: 14px;\r\n  margin-bottom: 0;\r\n}\r\n.childsaysprofileandfdropdown {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  height: 25px;\r\n}\r\n.childdropdownbutton {\r\n  background-color: #f3f2f0 !important;\r\n}\r\n.locationAddressText{\r\n  max-width: 160px;   /* adjust as needed */\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: block;\r\n  font-size: 12px;\r\n  color: rgba(0, 0, 0, 0.7);\r\n}\r\n.locationWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  min-width: 0;       /* 🔑 REQUIRED for truncation */\r\n  flex-shrink: 1;\r\n}\r\n.locationandtime {\r\n  display: flex; /* Align dot, icon, text in one row */\r\n  font-size: 12px; /* Slightly smaller than time */\r\n  color: #878585 !important;\r\n  align-items: center; /* Vertical alignment */\r\n  width: 100%; /* Allows ellipsis to work for location text */\r\n}\r\n.locationandtime img {\r\n  height: fit-content;\r\n  margin: 0px 3px 0px 3px;\r\n}\r\n.locationIcon {\r\n  margin-top: 0px !important;\r\n  margin-right: 3px !important;\r\n}\r\n.locationNameAndIconContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  gap: 3px;\r\n}\r\n.locationNameContent {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 600px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  margin-left: 2px;\r\n}\r\n.locationandtime img:first-child {\r\n  margin: 0 4px;\r\n}\r\n.followerandcount {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 4px;\r\n}\r\n.followerandcount > div > div {\r\n  font-size: 11px;\r\n  color: #373334;\r\n}\r\n.locationandtime span:first-child {\r\n  flex-shrink: 0;\r\n}\r\n.locationandtime span:last-child {\r\n  /* padding-left: 10px; */\r\n  flex-shrink: 1;\r\n  max-width: 250px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.locationandtime p {\r\n  margin-bottom: 0px;\r\n}\r\n/* @media screen and (max-width: 992px) and (min-width: 768px) {\r\n  .locationandtime span:last-child {\r\n    max-width: 130px;\r\n  }\r\n} */\r\n/* .askcount{\r\n    width: 14px;\r\n    height: 14px;\r\n    color: white;\r\n    font-size: 11px;\r\n    border-radius: 50%;\r\n    padding: 0 0 0 4px;\r\n} */\r\n.askcount {\r\n  background-color: #2168b2;\r\n  width: 14px;\r\n  height: 14px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n.saycount {\r\n  background-color: #45a735;\r\n  width: 14px;\r\n  height: 14px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n.updateCountContainer {\r\n  background-color: #e82727;\r\n  width: 14px;\r\n  height: 14px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n.tagcounter {\r\n  background-color: #efba29;\r\n  width: 25px;\r\n  height: 15px;\r\n  min-width: 15px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 5px;\r\n  text-align: center;\r\n}\r\n.nullTagCount,\r\n.tagcount {\r\n  background-color: #efba29;\r\n  width: 15px;\r\n  height: 15px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n.updatecount {\r\n  background-color: #e82727;\r\n  width: 14px;\r\n  height: 14px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n.childsaycount {\r\n  width: 14px;\r\n  height: 14px;\r\n  background-color: #36b549;\r\n  color: white;\r\n  font-size: 11px;\r\n  border-radius: 50%;\r\n  padding: 0 0 0 4px;\r\n  position: absolute;\r\n  right: 4px;\r\n  bottom: 0px;\r\n}\r\n\r\n.childsayprofileimage {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n.childsaytextandcolorlabel {\r\n  display: flex;\r\n  position: relative;\r\n  font-size: 14px;\r\n}\r\n.childsaytextandcolorlabel > div > p {\r\n  margin-bottom: 0;\r\n  font-size: 14px;\r\n}\r\n.dot {\r\n  height: fit-content;\r\n  margin: 0px 6px;\r\n}\r\n.nooflikes {\r\n  font-size: 14px;\r\n  margin: 3px 0px 0px 3px;\r\n}\r\n.spandisplay {\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 18px;\r\n  /* width: 50%; */\r\n}\r\n.locationTimeSpan {\r\n  display: flex; /* Puts all children in a horizontal line */\r\n  flex-direction: row; /* Ensure row layout (default but kept for clarity) */\r\n  justify-content: flex-end; /* Push items to the right when no location */\r\n  align-items: center; /* Perfect vertical alignment */\r\n  margin-top: 2px; /* Small top spacing */\r\n}\r\n.locationTimeSpan p {\r\n  width: 100%;\r\n}\r\n\r\n.childSayLocTxt {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n  display: block;\r\n  box-sizing: border-box; /* It will Consider padding and borders in width calculation */\r\n}\r\n\r\n@media screen and (max-width: 420px) {\r\n  .childSayLocTxt {\r\n    width: 60%;\r\n  }\r\n}\r\n@media screen and (min-width: 768px) and (max-width: 1200px) {\r\n  .childSayLocTxt {\r\n    width: 34%;\r\n  }\r\n}\r\n\r\n.childsaytime {\r\n  margin-bottom: 0; /* Removes unwanted extra spacing */\r\n  font-size: 13px; /* Time text size */\r\n  margin-left: auto; /* Push time text to the right side */\r\n  white-space: nowrap; /* Prevents wrapping (keeps in one line) */\r\n}\r\n.childsayopen {\r\n  display: block;\r\n}\r\n.childsayselection {\r\n  display: none;\r\n  padding-top: 10px;\r\n}\r\n.saycountbottom {\r\n  margin-bottom: 0;\r\n}\r\n.childpostBtnContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding-top: 8px;\r\n  gap: 5px;\r\n}\r\n.childpost {\r\n  color: white;\r\n  border-radius: 25px;\r\n  padding: 2px 15px;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 14px;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n.childpostCancelBtn {\r\n  background: transparent;\r\n  color: #373334;\r\n  border-radius: 25px;\r\n  padding: 2px 2px;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 14px;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n  outline: none !important;\r\n}\r\n.likeunlike {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 3px;\r\n}\r\n.likeunlike > a {\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #373334;\r\n}\r\n.likeunlike > a > img {\r\n  margin-right: 5px;\r\n  position: relative;\r\n  top: -1px;\r\n}\r\n.likeunlike > p {\r\n  margin-bottom: 0;\r\n}\r\n.likeunlike > p > img {\r\n  margin-right: 4px;\r\n}\r\n.followcount {\r\n  color: #878585;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  margin-top: 3px;\r\n}\r\n.childsaydropdowwbutton {\r\n  background: none !important;\r\n}\r\n.postbuttonandlabel {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  min-width: 270px;\r\n  font-size: 14px;\r\n  align-items: first baseline;\r\n}\r\n.postbuttonandlabel > label {\r\n  margin: 3px 10px 0px 0px;\r\n}\r\n.saveCancelButtonContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  margin-bottom: -5px;\r\n  font-size: 14px;\r\n}\r\n.editPost {\r\n  background-color: #2181ce;\r\n  color: white;\r\n  border-radius: 25px;\r\n  padding: 2px 16px;\r\n  border: none;\r\n  outline: none;\r\n  margin-top: 4px;\r\n  font-size: 14px;\r\n}\r\n.editCancelPost{\r\n  background: transparent;\r\n  color: #373334;\r\n  border-radius: 25px;\r\n  padding: 8px 2px 2px 2px;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 14px;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n  outline: none !important;\r\n}\r\n.cancelPost {\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n  margin-left: 20px;\r\n  font-size: 14px;\r\n}\r\n\r\n.postMessage {\r\n  display: none;\r\n  font-size: 14px;\r\n}\r\n.sendaMail {\r\n  background: #2181ce;\r\n  color: white;\r\n  outline: none;\r\n  border-radius: 25px;\r\n  border: none;\r\n  position: relative;\r\n  top: 10px;\r\n  align-self: center;\r\n  left: 124px;\r\n  padding: 3px 15px;\r\n  margin-bottom: 20px;\r\n  min-width: 88px;\r\n}\r\n.sendamailtextarea {\r\n  min-width: 325px;\r\n  border-radius: 0px;\r\n  outline: none;\r\n  border: solid 1px #dcdcdc;\r\n  padding: 5px 12px;\r\n  font-size: 14px;\r\n}\r\n.EditPostMessage {\r\n  position: relative;\r\n  width: 100%;\r\n  border: 10px;\r\n  border-radius: 10px;\r\n  padding: 8px 8px 10px 12px;\r\n  overflow-y: scroll;\r\n  scrollbar-width: none;\r\n  border: 1px solid #707070;\r\n  resize: none;\r\n  font-size: 14px;\r\n}\r\n.postAttachmentIconsAndActionBtnMainTopContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  padding-bottom: 10px;\r\n}\r\n.childAnsReplyPostBtnTopMainContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  padding-bottom: 20px;\r\n  padding-left: 50px;\r\n}\r\n.childAnsReplyPostBtnMainContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  /* flex-wrap: wrap; */\r\n  width: 100%;\r\n  /* padding-bottom: 20px; */\r\n}\r\n.postAttachmentIconsAndActionBtnContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  width: 100%;\r\n  margin-bottom: -13px;\r\n}\r\n.postAttachmentIconsContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  /* flex-wrap: wrap; */\r\n  margin-left: 5px;\r\n}\r\n.postLocationAttachmentTextContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  /* flex-wrap: wrap; */\r\n  margin-left: 5px;\r\n}\r\n\r\n.iconLabel {\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.attachIcon {\r\n  height: 17px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.editLocationIcon {\r\n  position: absolute; /* Positions it relative to the textareaContainer */\r\n  right: -4px; /* Adjust spacing from the right */\r\n  top: 15px; /* Vertically centers the icon */\r\n  transform: translateY(-50%); /* Corrects centering offset */\r\n  cursor: pointer; /* Optional: Changes the cursor to a pointer */\r\n}\r\n.editLocationIconAndReminder {\r\n  position: absolute; /* Positions it relative to the textareaContainer */\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  right: -4px; /* Adjust spacing from the right */\r\n  top: 15px; /* Vertically centers the icon */\r\n  transform: translateY(-20%); /* Corrects centering offset */\r\n  padding: 2px 10px;\r\n  height: 100%;\r\n  cursor: pointer; /* Optional: Changes the cursor to a pointer */\r\n}\r\n.textareaContainer {\r\n  position: relative; /* Makes the parent a containing block for absolutely positioned children */\r\n  width: 100%; /* Ensures the container wraps the textarea and icon */\r\n  display: inline-block; /* Prevents the container from expanding unnecessarily */\r\n  font-size: 14px;\r\n}\r\n.sendaMailModel {\r\n  display: flex;\r\n}\r\n.sendaMailModel > div > img,\r\n.postedcomment > div > img {\r\n  border-radius: 15px;\r\n  border: solid 1px #707070;\r\n}\r\n.locationpinchildpost {\r\n  position: relative;\r\n  right: 20px;\r\n  top: 9px;\r\n}\r\n.updatePopupLocationIcon {\r\n  margin-right: -5px;\r\n  /* margin: 0px; */\r\n}\r\n.locationsearch {\r\n  position: absolute;\r\n  top: 3.2rem;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 100%;\r\n  max-width: 600px;\r\n  z-index: 10;\r\n}\r\n.dateTime {\r\n  color: #707070;\r\n  margin-top: 1.5px;\r\n}\r\n.calendarHeaderText p {\r\n  color: #373334;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  margin-bottom: 0px;\r\n}\r\n@media screen and (min-width: 1440px) {\r\n  .calendarHeaderText {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n    height: 36px;\r\n    width: 265px;\r\n    margin-top: -85px;\r\n    margin-right: -268px;\r\n    padding-bottom: -10px;\r\n    border-style: solid;\r\n    border-top: none;\r\n    border-right: none;\r\n    border-left: none;\r\n    border-bottom-width: 2px;\r\n  }\r\n  .calendarHeaderText p {\r\n    color: #373334;\r\n    font-weight: 500;\r\n    font-size: 19px;\r\n  }\r\n}\r\n.comboboxdropdown {\r\n  z-index: 1301;\r\n}\r\n.addlocation {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n}\r\n.mapcontainer {\r\n  width: 100%;\r\n  padding: 0 15px 15px 15px;\r\n}\r\n.inputWrapper {\r\n  display: flex;\r\n  justify-content: center; /* keeps input centered */\r\n  width: 100%;\r\n}\r\n\r\n.comboinput {\r\n  width: 100%;\r\n  min-width: 600px;\r\n  min-height: 45px;\r\n  border-radius: 25px;\r\n  outline: none;\r\n  border: none;\r\n  box-sizing: border-box;\r\n  box-shadow: 2px 2px 2px 0px #888;\r\n  padding-left: 15px;\r\n}\r\n.locationheading {\r\n  margin-bottom: 0;\r\n  color: #373334;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-top: 2px;\r\n}\r\n.locationheading span {\r\n  font-weight: 700;\r\n}\r\n.locationSubmitAfterSelect {\r\n  outline: none;\r\n  border: none;\r\n  background-color: transparent;\r\n  color: #4795de;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n}\r\n.locationSubmitBeforeSelect {\r\n  outline: none;\r\n  border: none;\r\n  background-color: transparent;\r\n  color: #707070;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n}\r\n.locationSubmitButton {\r\n  color: #2181ce;\r\n  background-color: transparent;\r\n  border-width: 0px;\r\n  outline: none !important;\r\n}\r\n.editBioInfo {\r\n  display: block;\r\n}\r\n.editBioInfoNone {\r\n  display: none;\r\n}\r\n\r\n/* The container */\r\n.container {\r\n  display: block;\r\n  position: relative;\r\n  padding-left: 35px;\r\n  margin-bottom: 0;\r\n  cursor: pointer;\r\n  font-size: 22px;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n/* Hide the browser's default radio button */\r\n.container > .containerinput {\r\n  position: absolute;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Create a custom radio button */\r\n.checkmark {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 25px;\r\n  width: 25px;\r\n  background-color: #eee;\r\n  border-radius: 50%;\r\n}\r\n\r\n/* On mouse-over, add a grey background color */\r\n.container:hover .containerinput ~ .checkmark {\r\n  background-color: #ccc;\r\n}\r\n\r\n/* When the radio button is checked, add a blue background */\r\n.container > .containerinput:checked ~ .checkmark {\r\n  background-color: #2196f3;\r\n}\r\n\r\n/* Create the indicator (the dot/circle - hidden when not checked) */\r\n.checkmark:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  display: none;\r\n}\r\n\r\n/* Show the indicator (dot/circle) when checked */\r\n.container > .containerinput:checked ~ .checkmark:after {\r\n  display: block;\r\n}\r\n\r\n/* Style the indicator (dot/circle) */\r\n.container .checkmark:after {\r\n  top: 5.9px;\r\n  left: 5.9px;\r\n  width: 13px;\r\n  height: 13px;\r\n  border-radius: 50%;\r\n  background: white;\r\n}\r\n.postinfo {\r\n  padding: 0px 0px 10px 12px;\r\n}\r\n.postinfo > p {\r\n  margin-bottom: -8px;\r\n  font-size: 17px;\r\n}\r\n.postinfo > div {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.postinfo > div > p {\r\n  margin-top: 0px;\r\n  font-size: 17px;\r\n  color: #373334;\r\n  font-weight: 500;\r\n}\r\n.aboutCommunity {\r\n  font-weight: 400;\r\n  font-size: 13px !important;\r\n  color: #707070;\r\n  margin-top: -20px;\r\n}\r\n.selectmultiplecommunitys {\r\n  display: flex;\r\n}\r\n.selectmultiplecommunitys > div {\r\n  margin-top: 0px;\r\n  padding-left: 8px;\r\n  cursor: pointer;\r\n}\r\n.selectmultiplecommunitys > div span {\r\n  font-weight: 500;\r\n}\r\n.selectmultiplecommunitys > img {\r\n  margin-left: 12px;\r\n  margin-top: 3px;\r\n  cursor: pointer;\r\n  height: 18px;\r\n}\r\n.selectCount {\r\n  color: #373334;\r\n  font-weight: 500;\r\n  margin-left: 5px;\r\n}\r\n.selectCommunityBtn {\r\n  color: #707070;\r\n  cursor: pointer;\r\n  margin-left: 5px;\r\n}\r\n.postingoptionsradio {\r\n  display: flex;\r\n  margin-top: 25px;\r\n  justify-content: space-between;\r\n}\r\n.postingoptionschild {\r\n  display: flex;\r\n}\r\n.postdropdown {\r\n  float: right;\r\n  position: relative;\r\n  top: 5px;\r\n  right: 2px;\r\n  padding-left: 20px;\r\n  cursor: pointer;\r\n}\r\n.disableRadioOptions {\r\n  opacity: 0.5;\r\n  pointer-events: none;\r\n}\r\n.warningmsg {\r\n  text-align: center;\r\n  font-size: 12px;\r\n  padding: 2px 4px;\r\n  display: block;\r\n  margin: 0;\r\n  line-height: 1.2;\r\n  text-align: left;\r\n}\r\nbutton,\r\na {\r\n  cursor: pointer;\r\n}\r\n.moderatorcommunity {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n}\r\n.moderatorcommunity > img {\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 12px;\r\n  margin: 3px 18px 23px 10px;\r\n}\r\n.moderatorcommunity > p {\r\n  margin-top: 8px;\r\n}\r\n.moderatorcommunityparentdiv {\r\n  height: 400px;\r\n  scroll-behavior: smooth;\r\n  overflow-y: scroll;\r\n  padding-top: 10px;\r\n  scrollbar-width: none;\r\n}\r\n.moderatorcommunitychilddiv {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.inputCheckbox {\r\n  height: 18px;\r\n  width: 18px;\r\n}\r\n.editBioTextArea {\r\n  width: 100%;\r\n  resize: none;\r\n  padding: 3px 0 0 7px;\r\n  border: 1px solid #707070;\r\n  resize: none;\r\n  border-radius: 5px;\r\n  font-size: 14px;\r\n}\r\n.editbioSave {\r\n  float: none !important;\r\n  margin-top: 7px !important;\r\n  margin-right: 5px !important;\r\n  background-color: #337ab7;\r\n  width: 65px;\r\n  border-radius: 15px;\r\n  color: #ffffff;\r\n  font: bold;\r\n  border: none;\r\n  padding: 2px 8px;\r\n}\r\n.editbioCancel {\r\n  margin-bottom: -5px;\r\n}\r\n@media all and (max-width: 767px) {\r\n  .post {\r\n    margin: 10px;\r\n    padding: 10px;\r\n  }\r\n}\r\n\r\n.deletePost {\r\n  display: none;\r\n}\r\n\r\n.privateTagButtonContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  padding-top: 5px;\r\n}\r\n.privateButton {\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n  outline: none !important;\r\n  width: 50%;\r\n  padding: 2px !important;\r\n}\r\n.privateButtonDescriptionContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.privateButtonIconImage {\r\n  height: 16px;\r\n  margin-right: 6px;\r\n}\r\n.privateButtonParagraph {\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  color: #63555a;\r\n  text-transform: none;\r\n  margin: 0px;\r\n}\r\n.profileMessagePopupMainContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n}\r\n.privateTagdDownArrowButton {\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n  margin-right: 10px;\r\n  cursor: pointer;\r\n  margin-bottom: 10px;\r\n}\r\n.privateTagdDownArrowButton:focus {\r\n  outline: 0px solid blue;\r\n}\r\n.downArrow {\r\n  font-size: 23px;\r\n  font-weight: 100;\r\n}\r\n.privateTagPopup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  padding: 10px 10px;\r\n}\r\n.privateTagPopupItemButton {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n}\r\n.privateTagPopupItemButton:focus {\r\n  outline: 0px solid blue;\r\n}\r\n.editIcon {\r\n  height: 15px;\r\n  margin-right: 12px;\r\n  margin-top: 4px;\r\n}\r\n.privatePopuoTagName {\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  color: #63555a;\r\n}\r\n.loaderContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  margin-bottom: 15px;\r\n}\r\n.modalFooter {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: flex-end;\r\n  margin: auto;\r\n}\r\n.notFoundImageContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  gap: 8px;\r\n}\r\n.notFoundImageContainerParagraph1{\r\n  font-size: 18px;\r\n  color: #707070;\r\n  \r\n}\r\n.notFoundImageContainerParagraph2{\r\n  color: #373334;\r\n  font-size: 17px;\r\n}\r\n\r\n\r\n.contentClass {\r\n  background-color: #4795de;\r\n}\r\n\r\n.alertModal {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n}\r\n.alertModal div {\r\n  cursor: pointer;\r\n  margin-left: auto;\r\n}\r\n\r\n.alertModalContent {\r\n  background-color: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  text-align: center;\r\n  z-index: 1401; /* Higher than the modal container */\r\n}\r\n.avatarWrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.crown {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: 20px; /* Adjust the size of the crown icon */\r\n  height: 20px;\r\n  margin-right: 6px;\r\n  margin-bottom: 6px;\r\n}\r\n.activityAskPost {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n}\r\n.restrictionTestUnderSayPost {\r\n  color: gray;\r\n  text-align: center;\r\n  font-size: 15px;\r\n}\r\n.locationCharContainer {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  margin-left: 8px;\r\n  flex-wrap: nowrap;\r\n  overflow: hidden;\r\n}\r\n.locationText {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 5px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.saveCancelBtnContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n.childSayLocText {\r\n  max-width: 300px; /* Limit width for long location names */\r\n  white-space: nowrap; /* Prevent multi-line wrapping */\r\n  overflow: hidden; /* Hide overflow text */\r\n  text-overflow: ellipsis; /* Add \"...\" when truncated */\r\n}\r\n.childfileItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  border-radius: 6px;\r\n  padding: 4px 8px;\r\n  font-size: 14px;\r\n}\r\n.childfileLocationItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  border-radius: 6px;\r\n  padding: 4px 1px;\r\n  font-size: 14px;\r\n}\r\n\r\n.childfileName {\r\n  color: #707070;\r\n  font-weight: 500;\r\n  max-width: 180px;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n.childfileLocationName {\r\n  color: #707070;\r\n  font-weight: 500;\r\n  max-width: 100px;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n.removeBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n  cursor: pointer;\r\n  outline: none !important;\r\n  border-radius: 50%;\r\n  background-color: #f4f4f4;\r\n  padding: 4px;\r\n}\r\n.deleteIcon {\r\n  height: 16px;\r\n  width: 16px;\r\n}\r\n\r\n/* ✅ NEW: outer wrapper must allow shrinking */\r\n.calendarWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  min-width: 0;       /* 🔑 REQUIRED for truncation */\r\n  flex-shrink: 1;\r\n}\r\n\r\n/* ✅ NEW: text container */\r\n.calendarTextWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  min-width: 0;       /* 🔑 REQUIRED */\r\n  flex-shrink: 1;\r\n}\r\n\r\n/* ✅ NEW: truncation instead of wrapping */\r\n.calendarDateText {\r\n  max-width: 140px;   /* adjust based on modal width */\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: block;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allFeedMainContainer": `post_allFeedMainContainer__etYb1`,
	"notFollowingContainer": `post_notFollowingContainer__f86jD`,
	"post": `post_post__-vAWu`,
	"avatardetails": `post_avatardetails__rvXpT`,
	"profilename": `post_profilename__3uPe7`,
	"sayoutlinedots": `post_sayoutlinedots__Y7a5K`,
	"saysandfollow": `post_saysandfollow__TkY7h`,
	"noOfsays": `post_noOfsays__JjQkz`,
	"answerIcon": `post_answerIcon__W77Qg`,
	"replyIcon": `post_replyIcon__1Wi5j`,
	"noOffollows": `post_noOffollows__U5bF7`,
	"followtext": `post_followtext__ypo4x`,
	"comment": `post_comment__JLWD4`,
	"commentinput": `post_commentinput__9wmQk`,
	"postedcomment": `post_postedcomment__Qvv--`,
	"likebutton": `post_likebutton__BIYRE`,
	"likeandlikecount": `post_likeandlikecount__vU+W9`,
	"dropdown": `post_dropdown__LW78n`,
	"dropdownlinks": `post_dropdownlinks__agqlc`,
	"locationDet": `post_locationDet__iR7XQ`,
	"LocationPinIcon": `post_LocationPinIcon__nPnax`,
	"dropdownbutton": `post_dropdownbutton__2CGNs`,
	"divider": `post_divider__yOvs1`,
	"avatar": `post_avatar__F1OEq`,
	"profileimagetext": `post_profileimagetext__nin39`,
	"childResultMessage": `post_childResultMessage__QaEpI`,
	"childsayprofilename": `post_childsayprofilename__wQb2C`,
	"childsaysprofileandfdropdown": `post_childsaysprofileandfdropdown__fL1AC`,
	"childdropdownbutton": `post_childdropdownbutton__drQy-`,
	"locationAddressText": `post_locationAddressText__WQTUA`,
	"locationWrapper": `post_locationWrapper__Z0uTE`,
	"locationandtime": `post_locationandtime__qHbFJ`,
	"locationIcon": `post_locationIcon__uputS`,
	"locationNameAndIconContainer": `post_locationNameAndIconContainer__45sfx`,
	"locationNameContent": `post_locationNameContent__MdGUt`,
	"followerandcount": `post_followerandcount__n0oyn`,
	"askcount": `post_askcount__Df7Df`,
	"saycount": `post_saycount__RvQyG`,
	"updateCountContainer": `post_updateCountContainer__HTOon`,
	"tagcounter": `post_tagcounter__uLlHB`,
	"nullTagCount": `post_nullTagCount__E4Az8`,
	"tagcount": `post_tagcount__t0oKR`,
	"updatecount": `post_updatecount__wfVCc`,
	"childsaycount": `post_childsaycount__0tGIv`,
	"childsayprofileimage": `post_childsayprofileimage__0Ue+6`,
	"childsaytextandcolorlabel": `post_childsaytextandcolorlabel__-caIV`,
	"dot": `post_dot__0t-GE`,
	"nooflikes": `post_nooflikes__5zArq`,
	"spandisplay": `post_spandisplay__cKZmp`,
	"locationTimeSpan": `post_locationTimeSpan__8bNMZ`,
	"childSayLocTxt": `post_childSayLocTxt__mUDCG`,
	"childsaytime": `post_childsaytime__K04mw`,
	"childsayopen": `post_childsayopen__vLCGP`,
	"childsayselection": `post_childsayselection__GaqmL`,
	"saycountbottom": `post_saycountbottom__f5nEj`,
	"childpostBtnContainer": `post_childpostBtnContainer__Y3SqP`,
	"childpost": `post_childpost__cLW9L`,
	"childpostCancelBtn": `post_childpostCancelBtn__81wjE`,
	"likeunlike": `post_likeunlike__gL09U`,
	"followcount": `post_followcount__Ksqkf`,
	"childsaydropdowwbutton": `post_childsaydropdowwbutton__5i-fq`,
	"postbuttonandlabel": `post_postbuttonandlabel__Ssudu`,
	"saveCancelButtonContainer": `post_saveCancelButtonContainer__o2UMd`,
	"editPost": `post_editPost__b1j3K`,
	"editCancelPost": `post_editCancelPost__EnSw5`,
	"cancelPost": `post_cancelPost__2LfZh`,
	"postMessage": `post_postMessage__G28H2`,
	"sendaMail": `post_sendaMail__3PXSY`,
	"sendamailtextarea": `post_sendamailtextarea__Z-Z6P`,
	"EditPostMessage": `post_EditPostMessage__FkRs7`,
	"postAttachmentIconsAndActionBtnMainTopContainer": `post_postAttachmentIconsAndActionBtnMainTopContainer__TwIlX`,
	"childAnsReplyPostBtnTopMainContainer": `post_childAnsReplyPostBtnTopMainContainer__SrzFt`,
	"childAnsReplyPostBtnMainContainer": `post_childAnsReplyPostBtnMainContainer__Z32yj`,
	"postAttachmentIconsAndActionBtnContainer": `post_postAttachmentIconsAndActionBtnContainer__hmHMX`,
	"postAttachmentIconsContainer": `post_postAttachmentIconsContainer__k88bi`,
	"postLocationAttachmentTextContainer": `post_postLocationAttachmentTextContainer__q1Kg0`,
	"iconLabel": `post_iconLabel__Kh50I`,
	"attachIcon": `post_attachIcon__H7fTZ`,
	"editLocationIcon": `post_editLocationIcon__OU9Nd`,
	"editLocationIconAndReminder": `post_editLocationIconAndReminder__BluNH`,
	"textareaContainer": `post_textareaContainer__0pm4Q`,
	"sendaMailModel": `post_sendaMailModel__pi3T9`,
	"locationpinchildpost": `post_locationpinchildpost__qOR5D`,
	"updatePopupLocationIcon": `post_updatePopupLocationIcon__tZtr1`,
	"locationsearch": `post_locationsearch__VYVPr`,
	"dateTime": `post_dateTime__xxi6T`,
	"calendarHeaderText": `post_calendarHeaderText__Pjgqp`,
	"comboboxdropdown": `post_comboboxdropdown__j-m0M`,
	"addlocation": `post_addlocation__baFQv`,
	"mapcontainer": `post_mapcontainer__p8Wk5`,
	"inputWrapper": `post_inputWrapper__R+7RN`,
	"comboinput": `post_comboinput__V2sUl`,
	"locationheading": `post_locationheading__e3lht`,
	"locationSubmitAfterSelect": `post_locationSubmitAfterSelect__vst0q`,
	"locationSubmitBeforeSelect": `post_locationSubmitBeforeSelect__8UmJQ`,
	"locationSubmitButton": `post_locationSubmitButton__LW6+3`,
	"editBioInfo": `post_editBioInfo__aiMFW`,
	"editBioInfoNone": `post_editBioInfoNone__v3h8J`,
	"container": `post_container__itRcV`,
	"containerinput": `post_containerinput__VIF1z`,
	"checkmark": `post_checkmark__xGYCf`,
	"postinfo": `post_postinfo__M4sfp`,
	"aboutCommunity": `post_aboutCommunity__tLPEL`,
	"selectmultiplecommunitys": `post_selectmultiplecommunitys__T1rPM`,
	"selectCount": `post_selectCount__s1hLx`,
	"selectCommunityBtn": `post_selectCommunityBtn__kAHF7`,
	"postingoptionsradio": `post_postingoptionsradio__W6av8`,
	"postingoptionschild": `post_postingoptionschild__ogir4`,
	"postdropdown": `post_postdropdown__uuwuV`,
	"disableRadioOptions": `post_disableRadioOptions__rmL+l`,
	"warningmsg": `post_warningmsg__9Z4jE`,
	"moderatorcommunity": `post_moderatorcommunity__izEBp`,
	"moderatorcommunityparentdiv": `post_moderatorcommunityparentdiv__yek8r`,
	"moderatorcommunitychilddiv": `post_moderatorcommunitychilddiv__MGyyO`,
	"inputCheckbox": `post_inputCheckbox__h4yw8`,
	"editBioTextArea": `post_editBioTextArea__8B0iU`,
	"editbioSave": `post_editbioSave__19ped`,
	"editbioCancel": `post_editbioCancel__ueqrU`,
	"deletePost": `post_deletePost__zvCmP`,
	"privateTagButtonContainer": `post_privateTagButtonContainer__5E8Xv`,
	"privateButton": `post_privateButton__3ggb0`,
	"privateButtonDescriptionContainer": `post_privateButtonDescriptionContainer__Botcy`,
	"privateButtonIconImage": `post_privateButtonIconImage__GBQgz`,
	"privateButtonParagraph": `post_privateButtonParagraph__Tp2hN`,
	"profileMessagePopupMainContainer": `post_profileMessagePopupMainContainer__KC18b`,
	"privateTagdDownArrowButton": `post_privateTagdDownArrowButton__9+Zcs`,
	"downArrow": `post_downArrow__In1Ff`,
	"privateTagPopup": `post_privateTagPopup__8ZES3`,
	"privateTagPopupItemButton": `post_privateTagPopupItemButton__5di2P`,
	"editIcon": `post_editIcon__fXcSR`,
	"privatePopuoTagName": `post_privatePopuoTagName__3HW1A`,
	"loaderContainer": `post_loaderContainer__WbBqj`,
	"modalFooter": `post_modalFooter__yKVU9`,
	"notFoundImageContainer": `post_notFoundImageContainer__XKwYF`,
	"notFoundImageContainerParagraph1": `post_notFoundImageContainerParagraph1__oaFxY`,
	"notFoundImageContainerParagraph2": `post_notFoundImageContainerParagraph2__YxX+Y`,
	"contentClass": `post_contentClass__s2Tu2`,
	"alertModal": `post_alertModal__yZ17x`,
	"alertModalContent": `post_alertModalContent__ghic6`,
	"avatarWrapper": `post_avatarWrapper__UVKm6`,
	"crown": `post_crown__C1PGL`,
	"activityAskPost": `post_activityAskPost__5pNn9`,
	"restrictionTestUnderSayPost": `post_restrictionTestUnderSayPost__A1Yva`,
	"locationCharContainer": `post_locationCharContainer__PH6fP`,
	"locationText": `post_locationText__3dffM`,
	"saveCancelBtnContainer": `post_saveCancelBtnContainer__MtKVZ`,
	"childSayLocText": `post_childSayLocText__ieoDk`,
	"childfileItem": `post_childfileItem__VuXU3`,
	"childfileLocationItem": `post_childfileLocationItem__zK9X+`,
	"childfileName": `post_childfileName__DOsl6`,
	"childfileLocationName": `post_childfileLocationName__otYuq`,
	"removeBtn": `post_removeBtn__LNK4J`,
	"deleteIcon": `post_deleteIcon__V6Z7h`,
	"calendarWrapper": `post_calendarWrapper__qfd5x`,
	"calendarTextWrapper": `post_calendarTextWrapper__12Ps7`,
	"calendarDateText": `post_calendarDateText__HMMLT`
};
export default ___CSS_LOADER_EXPORT___;
